import { render } from "./UserSearchBox.vue?vue&type=template&id=0096e7aa&scoped=true&ts=true"
import script from "./UserSearchBox.vue?vue&type=script&lang=ts"
export * from "./UserSearchBox.vue?vue&type=script&lang=ts"

import "./UserSearchBox.vue?vue&type=style&index=0&id=0096e7aa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0096e7aa"]])

export default __exports__